/*
 * scroll fadein
 */
const scrollFadein = function() {

	const windowHeight = window.innerHeight;
	let perWindow;

	if (768 <= $(window).outerWidth()) {
		perWindow = 0.3; // PC
	} else {
		perWindow = 0.2; // SP
	}

	$('.js-scroll-fadein').each(function(){
		const elmPosition = $(this).offset().top;
		const scroll = $(window).scrollTop();

		const showPosition = elmPosition - windowHeight + (windowHeight * perWindow);

		if (scroll > showPosition){
			if (!$(this).hasClass('is-fadein')) {
				$(this).addClass('is-fadein');
			}
		} else {
			if ($(this).hasClass('js-scroll-remove') && $(this).hasClass('is-fadein')) {
				$(this).removeClass('is-fadein');
			}
		}
	});
}


/*
* scroll event
*/
$(window).scroll(function() {
	scrollFadein();
});
